import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ToastController } from 'ionic-angular';

import { AngularFireAuth } from 'angularfire2/auth';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
	email:string = '';
	password:string = '';


  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private afAuth: AngularFireAuth, 
    public toastCtrl: ToastController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
  }
  signInWithUserPassword() {
	
	  this.afAuth.auth.signInWithEmailAndPassword(this.email+'@rhyno.ch', this.password).catch(error => {
		  this.presentToast('Benutzername oder Passwort falsch.');
  	}).then(res => { 
      if (res){
  		  this.presentToast('Login erfolgreich');
  	  }
    });

  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top',
      showCloseButton: false
    });
    toast.present();
  }

  forgot(){
    this.afAuth.auth.sendPasswordResetEmail(this.email+'@rhyno.ch').then(result => {
      this.presentToast('Mail verschickt');
    }, error => {
      this.presentToast('Account existiert nicht');
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts